import Swiper from "swiper";

export function initHotelGrid() {
  $(".hotel-grid-mobile").each(function() {
    new Swiper($(this), {
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      navigation: {
        nextEl: $(this)
          .parents(".hotel-grid")
          .find(".swiper-button-next"),
        prevEl: $(this)
          .parents(".hotel-grid")
          .find(".swiper-button-prev")
      },
      pagination: {
        el: $(this)
          .parents(".hotel-grid")
          .find(".swiper-pagination"),
        type: "bullets"
      }
    });
  });
}

jQuery(function() {
  initHotelGrid();
});
